import { IMAGES_PATH_HELPER } from 'ui/utilities/staticAssetsPaths';

const labels = {
  Quote: {
    Landing: {
      PageTitle: 'Homeowners - Landing',
      PageDescription: 'Page captures details about the Address.',
    },
    QuickQuote: {
      PageTitle: 'Homeowners - Quote Indication',
      PageDescription: 'Page captures details about applicant and basic coverages.',
    },
    RiskQualifiers: {
      PageTitle: 'Homeowners - Application - Risk Qualifiers',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    VehicleInfo: {
      PageTitle: 'Commercial Auto - Vehicle Information',
      PageDescription: 'Page captures details about the vehicles.',
    },
    OperationDetails: {
      PageTitle: 'Operation Details',
      PageDescription: 'Page captures operation history & description of operation',
    },
    CoverageInfo: {
      PageTitle: 'Commercial Auto - Coverages Information',
      PageDescription: 'Page captures details about the different coverages.',
    },
  },
  Application: {
    // discuss
    PolicyHolder: {
      PageTitle: 'Homeowners - Application - Policy Holder',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    Coverage: {
      PageTitle: 'Homeowners - Application - Coverage',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    Property: {
      PageTitle: 'Homeowners - Application - Property',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    RiskQualifiers: {
      PageTitle: 'Homeowners - Application - Risk Qualifiers',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    Summary: {
      PageTitle: 'Digital Edge Policy',
      PageDescription: 'Page displays information captures so far.',
    },
    BusinessInfo: {
      PageTitle: 'Commercial Auto - Business Information',
      PageDescription: 'Page captures basic information about business.',
    },
    VehicleInfo: {
      PageTitle: 'Commercial Auto - Vehicle Information',
      PageDescription: 'Page captures details about the vehicles.',
    },
    DriverInfo: {
      PageTitle: 'Commercial Auto - Driver Information',
      PageDescription: 'Page captures details about the drivers.',
    },
    GeneralLiabilities: {
      PageTitle: 'General Liabilities',
      PageDescription: 'Page captuers general liability queries',
    },
    QuoteIndication: {
      PageTitle: 'Quote Indication',
      PageDescription: 'Page captures premium details',
    },
  },
  Endorsement: {
    PolicyHolder: {
      PageTitle: 'Endorsement - Policy Holder',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    Coverage: {
      PageTitle: 'Endorsement - Coverage',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    Property: {
      PageTitle: 'Endorsement - Property',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    RiskQualifiers: {
      PageTitle: 'Endorsement - Risk Qualifiers',
      PageDescription: 'Page captures and validates risks for qualification.',
    },
    DriverInfo: {
      PageTitle: 'Commercial Auto - Driver Information',
      PageDescription: 'Page captures details about the drivers.',
    },
    Summary: {
      PageTitle: 'Endorsement Summary',
      PageDescription: 'Page displays information captures so far.',
    },
  },
  Cancellation: {
    Landing: {
      PageTitle: 'Cancellation',
      PageDescription: 'Page captures details about cancellation of an application.',
      favicon: `${IMAGES_PATH_HELPER}/login-ca.png`,
    },
  },
  Reinstatement: {
    Landing: {
      PageTitle: 'Reinstatement',
      PageDescription: 'Page captures details about reinstatement of an application.',
      favicon: `${IMAGES_PATH_HELPER}/login-ca.png`,
    },
  },
  Analytics: {
    Index: {
      PageTitle: 'Analytics Landing',
      PageDescription: 'Page displays in depth analytics across various segments..',
    },
    AnalyticsTabs: {
      PolicyAnalytics: 'Policy Analytics',
      QuoteAnalytics: 'Quote Analytics',
      UnderwriterAnalytics: 'Underwriter Analytics',
    },
  },
  Dashboard: {
    AccountHub: {
      PageTitle: 'AccountHub',
      PageDescription: 'Page displays list of policies',
    },
  },
  Shared: {
    // ReviewForUW: "Risk will be submitted to Underwriter for further review and your Underwriter will contact you shortly. Do you want to proceed ?",
    ReviewForUW: 'UNDERWRITING RULES VIOLATED',
    MatchingRules: 'Matching rules',
    Login: {
      PageTitle: `Vital || Login`,
      PageDescription: 'Application login page.',
    },
  },
  MyCommunicationHub: {
    MyCommunicationHub: {
      PageTitle: 'My Communication Hub',
      PageDescription: 'Page displays various threads of the Logged in user.',
    },
  },
  Renewal: {
    BusinessInfo: {
      PageTitle: 'Commercial Auto - Business Information',
      PageDescription: 'Page captures basic information about business.',
    },
    BusinessLocation: {
      PageTitle: 'Commercial Auto - Business Locations',
      PageDescription: 'Page captures basic information about business locations.',
    },
    Summary: {
      PageTitle: 'Commercial Auto - Application Summary',
      PageDescription: 'Page displays information captures so far.',
    },
  },
};

export { labels };
